export const ROUTER_STATE_KEY_PREVENT_LOGIN_REDIRECT = 'preventLoginRedirect'
